import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { 
    faFacebook, 
    faLinkedinIn, 
    faTelegram, 
    faInstagram 
} from '@fortawesome/free-brands-svg-icons';

const iconMap = {
    faPhone: faPhone,
    faFacebook: faFacebook,
    faLinkedinIn: faLinkedinIn,
    faTelegram: faTelegram,
    faInstagram: faInstagram
};

export const useFontAwesomeIcon = () => {
    const getIcon = (iconType, className = '') => {
        const icon = iconMap[iconType];
        if (!icon) {
            console.warn(`Icon type "${iconType}" not found`);
            return null;
        }
        
        return <FontAwesomeIcon className={className} icon={icon} />;
    };

    return { getIcon };
};